import styled from "styled-components";
import { Card } from "@mui/material"

export const StyledDetailTextWrapper = styled('div')`
  position: relative;
  min-height: 50px;
  padding: 0 240px;
  @media (max-width: 1278px){
    padding: 0;
  }
`;

export const StyledDetailTextLabel = styled('h5')`
  ${({theme}) => `
    font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
    color: ${theme.uptimeColors.textColors.primary};
    margin: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px;
`}  
`;

export const StyledDetailText = styled(Card)`
  ${({theme}) => `
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    color: ${theme.uptimeColors.textColors.primary};
    line-height: ${theme.uptimeLineHeights.desktop.lh11}px !important ;
    margin: ${theme.uptimeSpace[0]}px;
    word-break: break-word;
    box-shadow: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[15]}px ${theme.uptimeSpace[2]}px rgb(36 14 47 / 6%) !important;
    border-radius: ${theme.uptimeSpace[6]}px !important;
    padding: ${theme.uptimeSpace[13]}px ${theme.uptimeSpace[15]}px;
    min-height: 140px;
    .label{
      font-weight: 600
    }
`}`;

